var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F00FF",
    d: "M40 6.24c9.285 0 17.63 3.205 23.25 8.97a25 25 0 0 1 12.59 5.45C69.535 7.41 56.475 0 40 0 23.75 0 10.6 7.4 4.22 20.61a25 25 0 0 1 11.446-5.235C21.18 9.36 29.87 6.24 40 6.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F00FF",
    d: "M60 60a20 20 0 0 1-13.93-5.65l-.01-.01a8 8 0 0 0-1.38-.835A11 11 0 0 0 40 52.5c-2.07 0-3.644.515-4.674 1.005q-.735.346-1.385.835l-.01.01A20 20 0 1 1 20 20h40a20 20 0 0 1 0 40"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArLogo);
export default __webpack_public_path__ + "static/media/arLogo.cdcf384be37c99d9cfd2e225c2bdcb15.svg";
export { ForwardRef as ReactComponent };